import axios from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'share-report',
  components: {},
})
export default class shareModal extends Vue {
  detailReport = { title: '', id: '' };

  created() {
    this.$root.$on('setDetailReportModal', this.setDetailReport);
  }
  destroy(): void {
    this.$root.$off('setDetailReportModal', this.setDetailReport);
  }

  setDetailReport(detailReport) {
    this.detailReport = detailReport;
    this.$bvModal.show('shareModalReport');
  }

  textShare = '';
  isSharingLink = false;
  selected = '';
  linkPublic = '';
  isShowMore = false;
  isCopy = false;
  textSearchEmail = '';
  checkTextShare = false;
  isBookmark = false;
  resultSearch = [];
  emailsSending = [];
  isSendingEmail = true;
  isLike = false;
  isDislike = false;

  shareOnFacebook() {
    const url = 'https://goover.ai/detail-report/' + this.detailReport.id;
    const linkShare = encodeURIComponent(url);
    const facebook = 'https://www.facebook.com/sharer/sharer.php?s=100&p[url]=' + linkShare;
    window.open(facebook, '_blank');
  }

  shareOnTwitter() {
    const url = 'https://goover.ai/detail-report/' + this.detailReport.id;
    const linkShare = encodeURIComponent(url);
    const tweet = 'https://twitter.com/intent/tweet?url=' + linkShare + '&via=DeepSignal';
    window.open(tweet, '_blank');
  }

  shareOnLinkedIn() {
    const url = 'https://goover.ai/detail-report/' + this.detailReport.id;
    const linkShare = encodeURIComponent(url);
    const linkedIn = 'https://www.linkedin.com/shareArticle?mini=true&url=' + linkShare;
    window.open(linkedIn, '_blank');
  }

  shareByLink() {
    this.isSharingLink = !this.isSharingLink;
    if (this.isSharingLink) {
      this.isCopy = false;
      this.linkPublic = '';
      this.selected = 'PUBLIC';
      this.textShare = '';
      this.textSearchEmail = '';
      const domain = location.href.split('/');
      for (let i = 0; i < domain.length - 1; i++) {
        if (domain[i].toLowerCase().includes('detail-report')) {
          return (this.linkPublic = location.href);
        } else {
          this.linkPublic += domain[i] + '/';
        }
      }
      this.linkPublic = this.linkPublic + 'detail-report/' + this.detailReport.id;
    }
  }

  handleCopy() {
    // console.log(this.linkPublic);
    this.isCopy = !this.isCopy;
    if (this.isCopy && this.linkPublic) {
      navigator.clipboard.writeText(this.linkPublic);
    }
  }

  searchEmail() {
    if (this.textSearchEmail) {
      axios.get('/api/admin/users/searchEmail', { params: { key: this.textSearchEmail } }).then(res => {
        this.resultSearch = res.data;
      });
    }
  }

  chooseEmail(email) {
    if (this.emailsSending.indexOf(email) == -1) {
      this.emailsSending.push(email);
    }
  }

  removeEmail(email) {
    const index = this.emailsSending.indexOf(email);
    this.emailsSending.splice(index, 1);
  }

  sendEmail() {
    if (this.textShare.length < 10) {
      this.checkTextShare = true;
      return;
    } else {
      this.checkTextShare = false;
    }
    const dayLocate = new Date().toLocaleString();
    if (this.emailsSending.length < 1) {
      return;
    }
    this.isSendingEmail = false;
    const mailParams = {
      emails: this.emailsSending,
      message: this.textShare,
      linkShare: this.linkPublic,
      dayShare: dayLocate,
    };
  }
}
